import { Link, useParams } from 'react-router-dom';
import { useSession } from '../store/session';

/**
 * What a 402 looks like.
 *
 * The distinction between 402 and 403 exists for exactly this screen: 403 means
 * "ask your head teacher", 402 means "here is what it costs". Rendering the
 * same "access denied" page for both sends a teacher who is one click from
 * buying a subscription to their administrator instead.
 */
export function UpgradePrompt({
  title,
  message,
  backTo,
}: {
  title: string;
  message: string;
  backTo?: string;
}) {
  const { orgSlug = '' } = useParams();
  const canManage = useSession(state =>
    state.permissions.includes('subscription@manage') || state.permissions.includes('*@*'),
  );

  return (
    <div className="mx-auto max-w-lg py-10 text-center">
      <span aria-hidden="true" className="text-4xl">
        🔒
      </span>
      <h1 className="mt-3 text-xl font-bold text-ink-900">{title}</h1>
      <p className="mt-2 text-sm text-ink-600">{message}</p>

      <div className="mt-6 flex flex-wrap justify-center gap-2">
        {canManage ? (
          <Link to={`/o/${orgSlug}/billing`} className="btn-primary">
            See membership options
          </Link>
        ) : (
          /*
            A member who cannot manage the subscription is told who can, rather
            than being shown a checkout they are not allowed to complete.
          */
          <p className="rounded-lg bg-ink-100 px-4 py-3 text-sm text-ink-700">
            Ask an administrator at your organisation to add you to its subscription.
          </p>
        )}
        {backTo && (
          <Link to={backTo} className="btn-secondary">
            Go back
          </Link>
        )}
      </div>
    </div>
  );
}
